import WidgetContext from 'embed_v2/components/Context'
import useDebounce from 'embed_v2/hooks/useDebounce'
import { useState, useCallback, useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementDropdownOptions, Label as LabelOptions, Variant } from 'core/types/element/element_dropdown'
import optionsPropTypes from 'PropsSpec'
import CommonDropdown from './common/Dropdown'

const extractStylesFn = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  width: '100%',
  height: '100%'
})

const formatOptionLabel = ({ label, sublabel }: Variant, options: ElementDropdownOptions['dropdown']['menu']) => {
  const extractStyles = (opts: LabelOptions) => ({
    color: `rgba(${opts.text_color})`,
    lineHeight: opts.line_height,
    textTransform: opts.text_transform,
    textDecoration: opts.text_decoration,
    letterSpacing: opts.letter_spacing,
    textShadow: opts.text_shadow,
    fontFamily: opts.font_family,
    fontSize: opts.font_size,
    fontWeight: opts.font_weight
  })

  const labelStyles = extractStyles(options.label)
  const sublabelStyles = extractStyles(options.sublabel)

  return (
    <div
      className="wf_reset wf_datetime_dropdown_option"
      style={{ display: 'flex', flexDirection: 'column', textAlign: options.text_align }}
    >
      <div style={labelStyles} className="wf_reset">
        {label}
      </div>
      <div style={sublabelStyles} className="wf_reset">
        {sublabel}
      </div>
    </div>
  )
}

type Props = {
  options: ElementDropdownOptions
}

const Dropdown = (props: Props) => {
  const { setViewerField, notification } = useContext(WidgetContext)
  const { options } = props
  const [value, setValue] = useState<Variant>()
  const errors = notification.errors[options.key]

  const debouncedChangeHandler = useDebounce(setViewerField)

  const onChange = useCallback(
    (val: Variant) => {
      setValue(val)
      debouncedChangeHandler(options.key, val.value)
    },
    [options.key]
  )

  const styles = extractStylesFn(options)

  return (
    <div style={styles} className="wf_reset wf_field wf_field_dropdown">
      <CommonDropdown
        formatOptionLabel={(data: Variant) => formatOptionLabel(data, options.dropdown.menu)}
        styles={options.dropdown}
        value={value}
        options={options.dropdown.variants}
        placeholder={options.placeholder}
        onChange={onChange}
        errorText={errors}
      />
    </div>
  )
}

Dropdown.propTypes = {
  options: optionsPropTypes('dropdown')
}

export default Dropdown
